import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useParams } from 'react-router-dom';
import api from '../services/api';

const DocumentDetails: React.FC = () => {
    const { docPath } = useParams();
    const [items, setItems] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if (!docPath) return;
            setLoading(true);
            try {
                const decoded = decodeURIComponent(docPath || '');
                const res = await api.get('/api/signatures');
                const all = res.data || [];
                const matches = all.filter((it: any) => (it.documentPath === decoded) || (it.plugsignDocumentKey === decoded));
                setItems(matches);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [docPath]);

    if (!docPath) return <Typography sx={{ p: 2 }}>Documento não informado</Typography>;

    return (
        <Box sx={{ p: 2 }}>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h6">Detalhes do Documento</Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>Caminho: {decodeURIComponent(docPath || '')}</Typography>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1">Pedidos relacionados</Typography>
                    <List>
                        {items.map((it: any) => (
                            <ListItem key={it._id}><ListItemText primary={`Pedido ${it._id}`} secondary={`Status: ${it.status}`} /></ListItem>
                        ))}
                    </List>
                    {loading && <Typography>Carregando...</Typography>}
                </Box>
            </Paper>
        </Box>
    );
};

export default DocumentDetails;
